export const accent = '#ec9871'
export const lightAccent = '#fae5db'
export const mediumAccent = '#c76552'
export const darkAccent = '#c7402d'
export const background0 = '#000000'
export const background1 = '#101010'
export const background2 = '#202020'
